/**
 * scrollTo that takes into account header height.
 * assumes the element in question is below the fold and only takes into account the "condensed" header height (i.e. no global banners)
 */
export function scrollTo(el, callback) {
    if (!el) {
        console.error("no element defined; unable to scroll to element");
    }
    else {
        let headerHeight = 0;
        const header = document.querySelector('.header__top-bar');
        if (header) {
            headerHeight += header.offsetHeight;
        }
        const offset = +((el.getBoundingClientRect().top + window.scrollY) - headerHeight).toFixed();
        if (callback) {
            const onScroll = function () {
                const buffer = 2;
                if (+window.scrollY.toFixed() >= (offset - buffer)) {
                    window.removeEventListener('scroll', onScroll);
                    callback();
                }
            };
            onScroll();
            window.addEventListener('scroll', onScroll);
        }
        window.scrollTo({
            top: offset,
            left: 0,
            behavior: 'smooth'
        });
    }
}
